module.exports = __webpack_public_path__ + "img/xero-pad.6499e66e.png";